import React from "react";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
    progressContainer :{
        display: "flex",
        justifyContent: "space-between",
        borderRadius: 5,
        width: "100%",
        margin: "20px auto",
        position: "relative",
        top: "41px"
      },      
      dot : {
        height: 2,
        width: 2,
        backgroundColor: theme.palette.primary.main,
        borderRadius: "50%",
        position: "relative",
        zIndex: 2,
        '&$active':{
            backgroundColor: theme.white
        }
      },     
      active:{

      }
})

const ProgressStepper = ({ steps, currentStep, classes }) => {
  return (
    <div className={classes.progressContainer}>
      {Array.from({ length: steps }, (_, index) => (
        <div
          key={index}
          className={`${classes.dot} ${index < currentStep ? classes.active : ""}`}
        ></div>
      ))}
    </div>
  );
};

export default withStyles(styles)(ProgressStepper);
